/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_Send_FailedInputs */



/**
* | output |
* | --- |
* | "The sign-in link could not be sent. Try again in a moment." |
*
* @param {Invite_X15_Send_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_x15_send_failed = /** @type {((inputs?: Invite_X15_Send_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Send_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("The sign-in link could not be sent. Try again in a moment.")
});